(function () {
    'use strict';

    angular
        .module('searchV2Module')
        .config(['searchV2ServiceProvider', function (searchV2ServiceProvider) {

            searchV2ServiceProvider.setStateParamsConfig({
                start: { value: undefined, resetValue: undefined }, // offset: 0-based
                p: { value: undefined, resetValue: undefined}, // pageNb: 0-based
                n: { value: "9"}, // max nb of items per page
            });

            searchV2ServiceProvider.stateParamsToSourceQueryParamsTransformers.push(function (stateParams, searchSource) {
                var pageNb = 0;
                if (!_.isUndefined(stateParams.p)) pageNb = parseInt(stateParams.p, 10);

                var maxNbPerPage = parseInt(stateParams.n, 10);
                var start = stateParams.start || pageNb * maxNbPerPage;

                searchSource.queryParams.start = start;
                searchSource.queryParams.n = maxNbPerPage;
            });

            searchV2ServiceProvider.searchResultToContextTransformers.push(function (searchCtxt, stateParams, isSourceTypeSelected) {

                var nbSelectedSources = _.size(searchCtxt.sources);

                searchCtxt.sources = _.map(searchCtxt.sources, function (sourceCtxt) {
                    if (_.isEmpty(sourceCtxt.searchResponse)) return sourceCtxt;

                    var searchResponseResults = sourceCtxt.searchResponse.response;
                    var maxNbPerPage = Math.floor(parseInt(stateParams.n, 10));
                    var startOffset = parseInt(stateParams.start || 0, 10);
                    if (!isSourceTypeSelected) maxNbPerPage = Math.floor(maxNbPerPage / nbSelectedSources);
                                       
                    maxNbPerPage = Math.max(maxNbPerPage, (sourceCtxt.maxSearchResults || 0));

                    sourceCtxt.results = _.take(searchResponseResults.docs, maxNbPerPage);
                    sourceCtxt.numFound = searchResponseResults.numFound;

                    sourceCtxt.paging = {};
                    sourceCtxt.paging.pagesCount = Math.ceil(searchResponseResults.numFound / maxNbPerPage);
                    sourceCtxt.paging.pageNb = parseInt(stateParams.p || 0, 10);
                    sourceCtxt.paging.start = startOffset || sourceCtxt.paging.pageNb * maxNbPerPage;
                    sourceCtxt.paging.resultStartNb = sourceCtxt.paging.start + 1;
                    sourceCtxt.paging.resultEndNb = sourceCtxt.paging.start + sourceCtxt.results.length;
                    
                    return sourceCtxt;
                });
              
            });
        }])
        .directive('searchPager', directive);

    directive.$inject = [];

    function directive() {
        return {
            restrict: 'AE',
            scope: {
                resultsTitle: '@',
                resultsIcon: '@',
                searchCtxt: '=',
                searchSource: '=',
                version: '@?',
                selectionService: '=?',
            },
            template: '<div ng-include="getTemplateUrl()"></div>',
            controller: ['$scope', 'searchV2Service', function ($scope, searchV2Service) {
                $scope.getTemplateUrl = function () {
                    if (!$scope.version) $scope.version = 'default';

                    return  '/app/shared/searchV2/searchPager-' + $scope.version + '.tpl.html';
                };

                if ($scope.selectionService) {
                    $scope.selectionService.searchSource = $scope.searchSource;
                }

                $scope.showMoreSourceResults = function () {
                    searchV2Service
                      .search({
                          sourceType: $scope.searchSource.sourceType,
                      }).then(function (searchCtxt) {
                          $scope.searchCtxt = searchCtxt;
                      });
                };

                $scope.showLessSourceResults = function () {
                    searchV2Service
                      .search({
                          sourceType: undefined,
                      }).then(function (searchCtxt) {
                          $scope.searchCtxt = searchCtxt;
                      });
                };

                $scope.showMoreSourceResultsAction = function () {
                    if (_.isUndefined($scope.searchSource.paging)) return false;
                    if (!$scope.searchSource.results.length) return false;

                    return !$scope.searchCtxt.sourceType;
                };

                $scope.isPagingEnabled = function () {
                    if (_.isUndefined($scope.searchSource.paging)) return false;
                    if (!$scope.searchCtxt.sourceType) return false;
                    if (!$scope.searchSource.results.length) return false;

                    return $scope.searchSource.paging.pagesCount > 1;
                };

                $scope.isPreviousPageActionDisabled = function () {
                    if (_.isUndefined($scope.searchSource.paging)) return true;
                    if (_.isUndefined($scope.searchSource)) return true;

                    return $scope.searchSource.paging.pageNb === 0;
                };

                $scope.isNextPageActionDisabled = function () {
                    if (_.isUndefined($scope.searchSource.paging)) return true;
                    if (_.isUndefined($scope.searchSource)) return true;

                    return $scope.searchSource.paging.pageNb === ($scope.searchSource.paging.pagesCount - 1);
                };

                $scope.showPreviousPage = function () {
                    if ($scope.isPreviousPageActionDisabled()) return;

                    searchV2Service
                        .search({
                            p: $scope.searchSource.paging.pageNb - 1,
                        }).then(function (searchCtxt) {
                            $scope.searchCtxt = searchCtxt;
                        });
                };

                $scope.showNextPage = function () {
                    if ($scope.isNextPageActionDisabled()) return;

                    searchV2Service
                        .search({
                            p: $scope.searchSource.paging.pageNb + 1,
                        }).then(function (searchCtxt) {
                            $scope.searchCtxt = searchCtxt;
                        });
                };

            }]
        };
    }

})();